export const odluka_rasp_i_upotrebi_dobiti = {
  templateId: 206,
  category: 4,
  templateTitle: 'Odluka o raspodjeli i upotrebi dobiti',
  templateDescription: `<p>Odluka o raspodjeli dobiti/pokriću gubitka predstavlja javni dio registra GFI te istu donose članovi društva na skupštini uz pridržavanje obveza iz Zakona o trgovačkim društvima i Zakona o računovodstvu.</p>`,
  description: `
  <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
  
  <p>Odluka o raspodjeli dobiti ili pokriću gubitka, prema Zakonu o računovodstvu predstavlja javni dio registra godišnjih financijskih izvještaja.</p>
  <p>O utvrđivanju godišnjih financijskih izvještaja i podjeli dobiti/pokriću gubitka odlučuju članovi društva na skupštini.</p>
  <p>Glavna skupština odlučuje u pitanjima koja su izričito određena zakonom i osnivačkim aktom društva, a osobito o upotrebi dobiti/pokriću gubitka.  </p>
  <p>Odluku o podjeli dobiti i pokriću gubitka ne može donijeti uprava ili direktor. Oni mogu dati samo prijedlog za raspodjelu dobiti odnosno pokriće gubitka.</p>
  <p>Dobit se raspoređuje prvo prema odredbama Zakona o trgovačkim društvima pa prema odredbama Zakona o računovodstvu, a preostali dio nakon toga se  onda se može isplatiti vlasnicima.  </p>
  <p>Dobit društva s ograničenom odgovornošću obvezno se raspoređuje za pokriće gubitaka prenesenih iz ranijih godina (ukoliko postoje), za unos u rezerve za otkup vlastitih poslovnih udjela (ako ih je društvo steklo ili ih namjerava steći), za unos u rezerve određene društvenim ugovorom (ukoliko je tako određeno društvenim ugovorom) te za unos u rezerve prema odluci skupštine/vlasnika (ukoliko takva odluka postoji).  </p>
  <p>Ostvarena neto dobit nije nužno dobit koja se može isplatiti vlasnicima, ukoliko za isplatu nisu ostvareni preduvjeti, Zakona o trgovačkim društvima, pa prema odredbama Zakona o računovodstvu.</p>

  <h5>PRAVNA OSNOVA</h5>
  <p>Zakon o računovodstvu, Zakon o trgovačkim društvima.</p>
  `,
  sides: [
      {
          prefix: 'Na temelju odredbi Zakona o trgovačkim društvima i Zakona o računovodstvu,',
          signature: 'Predsjednik skupštine',
          inputs: [{
              type: "input",
              required: true,
              placeholder: "Poslovni subjekt",
            },
            {
              type: "input",
              required: true,
              placeholder: "Ulica i kućni broj",
            },
            {
              type: "input",
              required: true,
              placeholder: "Mjesto",
            },
            {
              type: "input",
              required: true,
              placeholder: "OIB",
            },
            {
              type: "input",
              placeholder: "Zastupa",
              inSignature: true,
            },
            {
              type: "input",
              placeholder: "Funkcija",
              inSignature: true,
            }],
            suffix: " (u daljnjem tekstu: Društvo),",
      }
  ],

  headline: '​donosi sljedeću',
  title: 'ODLUKU O RASPODJELI I UPOTREBI DOBITI',
  noArticleNumbers: true,

  articles: [
   
    {
      title: '',
      mandatory: false,
      exampleContent: true,
      statements: [
          {
              type: 'text',
              editable: true,
              mandatory: true,
              content: 'Prema usvojenim financijskim izvještajima, dobit poslovne godine _____ iznosi _______ kn. \r\nZadržana dobit iz prethodnih razdoblja iznosi _______ kn te s rasporedom dobiti iz ove poslovne godine čini ukupnu svotu dobiti.',
              value: '',
          }],
  },
  
  {
    title: '',
    mandatory: true,
    exampleContent: true,
    statements: [
        {
            type: 'choice',
            mandatory: true,
            editable: true,
            choices: [
                'Iz prethodnih razdoblja nema zadržane dobiti, kao niti prenesenog gubitka pa dobit poslovne godine čini ukupnu svotu dobiti, stoga se ukupna dobit u potpunosti se raspoređuje u zadržanu dobit.',
                'Preneseni gubitak iz prethodnih razdoblja iznosi _____ kn, stoga će se ostvarenom dobiti u 201_. godini u iznosu od _________ kn pokriti preneseni gubitak iz prethodnih razdoblja.',    
                'Preneseni gubitak iz prethodnih razdoblja iznosi ______kn, stoga će se ostvarenom dobiti u 201__. godini u iznosu od ________ kn pokriti preneseni gubitak iz prethodnih razdoblja, dok će se preostali iznos rasporediti u zadržanu dobit.',
                'Zadržana dobit iz prethodnih razdoblja iznosi ________, stoga ukupna svota dobiti za isplatu iznosi _________  te se ista kao ukupna dobit u potpunosti raspoređuje u zadržanu dobit.',          
                   ],
            placeholder: "Odaberite ovdje te potom izmijenite po želji...",  
        }
    ]
  },
{
    title: '',
    mandatory: false,
    exampleContent: true,
    statements: [
        {
            type: 'text',
            mandatory: true,
            editable: true,
            content: 'Dobit se smatra zadržanom sve dok se zahtjevom pojedinog člana društva, a po ispunjenim uvjetima (likvidnost društva), ne zatraži i ne izvrši isplata (djelomična ili cjelokupna), na način definiran u zahtjevu člana društva. Članovi društva koji su dobit predujmljivali moraju donijeti odluku o pokriću tog predujma.',
            value: '',
        }],
},

  {
      title: '',
      mandatory: false,
      statements: [
          {
              type: 'text',
              mandatory: true,
              editable: true,
              content: 'Odluka se primjenjuje s danom donošenja.',
              value: '',
          }],
  },
 
  {
    mandatory: true,
    static: true,
    type: 2, // date and place
    statements: [
        {
            type: 'input',
            mandatory: true,
            parts: [
                {
                    type: 'text',
                    content: 'U'
                },
                {
                    type: 'input',
                    value: '',
                    placeholder: "Upišite mjesto.",
                    required: true
                },
                {
                    type: 'text',
                    content: ', dana'
                },
                {
                    type: 'date',
                    value: new Date(),
                    required: true
                },
                {
                    type: 'text',
                    content: 'godine.',
                }
            ]
        },
    ]
},
{
    mandatory: true,
    static: true,
    type: 3,  // signatures
    statements: [],
},
{
    static: true,
    mandatory: false,
    type: 4, 
    statements: [
        {
            type: 'text',
            mandatory: true,
            editable: true,
            content: 'Dostaviti:\r\n1) Odjel knjigovodstva \r\n2) Arhiva',
            help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
        }
    ]
},
],
};









// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/206_odluka_rasp_i_upotrebi_dobiti.ts